import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { jwtDecode } from "jwt-decode";
import "./Navbar.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHouse, faInfoCircle, faPhone, faSignInAlt,  faUserPlus, faTachometerAlt,} from '@fortawesome/free-solid-svg-icons';
import { Menu,X } from "lucide-react";
export default function NavBar() {
  const { token } = useContext(AuthContext)
  const [isOpen,setIsOpen]=useState(false)
  const toggleNavBar=()=>{
    setIsOpen(!isOpen)
  }
  let role = "";
  if (token) {
    let decodedToken = jwtDecode(token)
    role = decodedToken.sub.role   
  }
  
  return (
    <div className="navbar-container mt-2 items-end max-w-full min-w-fit">
    <div className="navbar">
      <div className="navbar-links hidden bg-blue-200 rounded-2xl items-end flex flex-row justify-between space-x-12 mr-12">
        <Link to="/" className="mobile-link mt-5">
          <FontAwesomeIcon icon={faHouse}/>
          <p>Home</p>
        </Link>
        <Link to="/about" className="mobile-link">
          <FontAwesomeIcon icon={faInfoCircle} />
          <p>About</p>
        </Link>
        <Link to="/contact" className="mobile-link">
          <FontAwesomeIcon icon={faPhone} />
          <p>Contact</p>
        </Link>
        {!token && (
          <>
            <Link to="/registerUser" className="mobile-link">
              <FontAwesomeIcon icon={faUserPlus} />
              <p>Register</p>
            </Link>
            <Link to="/loginUser" className="mobile-link">
              <FontAwesomeIcon icon={faSignInAlt} />
              <p>Login</p>
            </Link>
          </>
        )}
        {token && (
          <>
            {role === "admin" && (
              <Link to="/adminDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dashboard</p>
              </Link>
            )}
            {role==="bank_owner" &&
             <Link to="/bankOwnerDash" className="mobile-link" onClick={toggleNavBar}>
               <FontAwesomeIcon icon={faTachometerAlt}/>
               <p>Dashboard</p>
            </Link>
            }             
            {
            role === "customer" && (
              <Link to="/customerDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dashboard</p>
              </Link>
            )}
            {
            role === "farmer" && (
              <Link to="/farmerDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dashboard</p>
              </Link>
            )}
            {
            role === "hotel_owner" && (
              <Link to="/hotelOwnerDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dashboard</p>
              </Link>
            )}

            {role === "transport_owner" && (
              <Link to="/transportOwnerDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dashboard</p>
              </Link>
            )}
          </>
        )}
      </div>
      <button onClick={toggleNavBar} className="menu-button md:hidden">
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
    </div>

    {isOpen && (
      <div className="mobile-menu bg-blue-200">
        <button onClick={toggleNavBar} className="close-button">
          <X size={24} />
        </button>
        <Link to="/" className="mobile-link" onClick={toggleNavBar}>
          <FontAwesomeIcon icon={faHouse} />
          <p>Home</p>
        </Link>
        <Link to="/about" className="mobile-link" onClick={toggleNavBar}>
          <FontAwesomeIcon icon={faInfoCircle} />
          <p>About</p>
        </Link>
        <Link to="/contact" className="mobile-link" onClick={toggleNavBar}>
          <FontAwesomeIcon icon={faPhone} />
          <p>Contact</p>
        </Link>
        {!token && (
          <>
            <Link to="/registerAdmin"></Link>
            <Link to="/registerUser" className="mobile-link" onClick={toggleNavBar}>
              <FontAwesomeIcon icon={faUserPlus} />
              <p>Register</p>
            </Link>
            <Link to="/loginUser" className="mobile-link" onClick={toggleNavBar}>
              <FontAwesomeIcon icon={faSignInAlt} />
              <p>Login</p>
            </Link>
          </>
        )}
        {token && (
          <>
            {role === "admin" && (
              <Link to="/adminDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dash</p>
              </Link>
            )}
            {role==="bank_owner" &&
             <Link to="/bankOwnerDash" className="mobile-link" onClick={toggleNavBar}>
               <FontAwesomeIcon icon={faTachometerAlt}/>
               <p>Dash</p>
            </Link>
            }             
            {
            role === "customer" && (
              <Link to="/customerDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dash</p>
              </Link>
            )}
            {
            role === "farmer" && (
              <Link to="/farmerDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dash</p>
              </Link>
            )}
            {
            role === "hotel_owner" && (
              <Link to="\hotelOwnerDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dash</p>
              </Link>
            )}

            {role === "transport_owner" && (
              <Link to="\transportOwnerDash" className="mobile-link" onClick={toggleNavBar}>
                <FontAwesomeIcon icon={faTachometerAlt} />
                <p>Dash</p>
              </Link>
            )}
          </>
        )}
      </div>
    )}
  </div>
  )
}
